import React from 'react';
import { Button, Icon, Toolbar } from '@fanadise/common-ui';
import { Link } from 'react-router-dom';
import { PlusIcon } from '@heroicons/react/solid';
import NftConfigList from 'components/nftConfigs/NftConfigsList/NftConfigsList';
import { Translate } from '@fanadise/common-logic';

const NftConfigsRouteList: React.FC = () => (
  <>
    <Toolbar
      mb="8"
      title={<Translate id="nftConfigs:list:title" />}
      actions={
        <Link to="add">
          <Button tag="span" icon={<Icon icon={PlusIcon} />}>
            <Translate id="nftConfigs:add:title" />
          </Button>
        </Link>
      }
    />

    <NftConfigList />
  </>
);

export default NftConfigsRouteList;
